const styles = theme => ({
    h1: {
        fontFamily: 'Montserrat, Arial',
        fontWeight: '700',
        fontSize: '100px',
        display: 'table',
        lineHeight: '122px',
        textTransform: 'uppercase',
        margin: 0,
        color: 'white',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 600)]: {
            fontSize: '55px',
            lineHeight: '66px',
            textAlign: 'center'
        }
    },
    video: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        backgroundSize: 'cover',
        overflow: 'hidden',
        minHeight: '100%',
        minWidth: '100%'
    },
    root: {
        backgroundRepeat: 'no-repeat !important',
        minHeight: '641px',
        position: 'relative',
        [theme.breakpoints.up(theme.breakpoints.values.xs + 1400)]: {
            backgroundSize: 'cover !important'
        },
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        boxShadow: '0 4px 14px 0 rgb(0 0 0 / 10%)',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            maxHeight: '500px',
            minHeight: '500px'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 500)]: {
            maxHeight: '500px',
            minHeight: '500px'
        }
    },
    h3: {
        fontFamily: 'Montserrat, Arial',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '24px',
        lineHeight: '45px',
        textTransform: 'uppercase',
        margin: 0,
        letterSpacing: '0.02em',
        color: 'white',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 600)]: {
            fontSize: '20px',
            lineHeight: '37px',
            padding:'15px',
        }
    }
})

export default styles